import classNames from 'classnames';
import { memo, useCallback, useState } from 'react';

import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Sheet } from '@sravni/react-design-system/lib/Sheet';
import type { SheetProps } from '@sravni/react-design-system/lib/Sheet';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Text, Heading } from '@sravni/react-design-system/lib/Typography';
import { ArrowRight } from '@sravni/react-icons';
import { Image } from '@sravni/react-image';
import { useIsMobile } from '@sravni/react-utils';

import styles from './SeoExperts.module.scss';
import { StarIcon } from './Star';

const TooltipContent = memo<{ item: Record<string, any>; className?: string }>(({ item, className }) => (
  <Space className={classNames(styles.tooltip, className)}>
    <Heading className="desktop:hidden" level={3}>
      Мнение эксперта
    </Heading>

    <Space className={styles.expertTooltipBlock}>
      <img
        className={styles.tooltipAvatar}
        src={`https://f.sravni.ru/avatars/${item.expertId}-s.svg`}
        alt={item.name}
      />

      <Space className={styles.names} direction="column">
        <Text className={styles.name}>{item.name}</Text>
        <Text className={styles.role}>{item.role}</Text>
      </Space>
    </Space>
    <Space className={styles.achievements} dangerouslySetInnerHTML={{ __html: item.description }} />
    <Text dangerouslySetInnerHTML={{ __html: item.text }} />
  </Space>
));

const ExpertCard = ({
  item,
  opened,
  onOpen,
  onClose,
}: {
  item: Record<string, any>;
  opened: boolean;
  onOpen: (id: string) => void;
  onClose: SheetProps['onClose'];
}) => (
  <Space className={styles.expertItem} onClick={() => onOpen(item.expertId)}>
    <Image className={styles.expertAvatar} src={`https://f.sravni.ru/avatars/${item.expertId}-s.svg`} alt={item.name} />

    <Space className={styles.names} direction="column">
      <Text className={styles.name}>{item.name}</Text>
      <Text className={styles.role}>{item.role}</Text>
    </Space>
    <Icon className="desktop:hidden" icon={<ArrowRight />} />
    <Sheet closeOnBackward className={styles.sheet} visible={opened} onClose={onClose}>
      <TooltipContent item={item} />
    </Sheet>
    <TooltipContent item={item} className="mobile:hidden" />
  </Space>
);

export const SeoExperts = ({ block }) => {
  const isMobile = useIsMobile();
  const [openedExpert, setOpenedExpert] = useState<string | null>(null);

  const handleClose = useCallback((event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setOpenedExpert(null);
  }, []);

  const handleSelectExpert = useCallback(
    (id: string) => {
      if (!isMobile) {
        return;
      }
      setOpenedExpert(id);
    },
    [isMobile],
  );

  return (
    <Space className={styles.expertBlock}>
      <Space className={styles.titleBlock} align="center">
        <div className={styles.logo}>
          <StarIcon />
        </div>
        <Text className={styles.title}>Информация на странице проверена финансовыми экспертами</Text>
      </Space>

      <div className={styles.container}>
        {block.answersData.map((item) => (
          <ExpertCard
            key={item.expertId}
            item={item}
            opened={item.expertId === openedExpert}
            onOpen={handleSelectExpert}
            onClose={handleClose}
          />
        ))}
      </div>
    </Space>
  );
};
